class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.isPlaying = false;
    this.#abortController = new AbortController();
    this.refs = {}; // simple refs system
  }

  #abortController;

  connectedCallback() {
    // collect refs based on [ref="..."]
    this.querySelectorAll("[ref]").forEach(el => {
      this.refs[el.getAttribute("ref")] = el;
    });

    const signal = this.#abortController.signal;

    // stop other media when this starts
    document.addEventListener("deferred-media:started", this.pauseMedia.bind(this), { signal });

    // stop on dialog close (if used anywhere)
    window.addEventListener("deferred-media:dialogClose", this.pauseMedia.bind(this), { signal });

    super.connectedCallback?.();

    const playBtn = this.querySelector("[ref='deferredMediaPlayButton']");
    if (playBtn) {
      playBtn.addEventListener("click", () => {
        // First time click loads video
        if (!this.hasAttribute("data-media-loaded")) {
          this.showDeferredMedia();
        } else {
          this.toggleMedia();
        }
      });
    }
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  // updatePlayPauseHint(isPlaying) {
  //   const toggleMediaButton = this.refs.toggleMediaButton;
  //   if (toggleMediaButton instanceof HTMLElement) {
  //     toggleMediaButton.classList.remove("hidden");
  //     const playIcon = toggleMediaButton.querySelector(".icon-play");
  //     if (playIcon) playIcon.classList.toggle("hidden", isPlaying);
  //     const pauseIcon = toggleMediaButton.querySelector(".icon-pause");
  //     if (pauseIcon) pauseIcon.classList.toggle("hidden", !isPlaying);
  //   }
  // }
	updatePlayPauseHint(isPlaying) {
		// Find the play/pause button inside this deferred media
		const toggleMediaButton = this.querySelector(".deferred-media__poster-button");
		if (toggleMediaButton instanceof HTMLElement) {
			toggleMediaButton.classList.remove("hidden");

			const playIcon = toggleMediaButton.querySelector(".icon-play");
			if (playIcon) playIcon.classList.toggle("hidden", isPlaying);

			const pauseIcon = toggleMediaButton.querySelector(".icon-pause");
			if (pauseIcon) pauseIcon.classList.toggle("hidden", !isPlaying);
		}
	}


  showDeferredMedia = () => {
    this.loadContent(true);

    // notify others that media started
    this.dispatchEvent(new CustomEvent("deferred-media:started", { bubbles: true, detail: { element: this } }));
  };

loadContent() {
  if (this.hasAttribute("loaded")) return;

  const template = this.querySelector("template");
  if (!template) return;

  const content = template.content.firstElementChild.cloneNode(true);
  this.setAttribute("loaded", true);
  this.appendChild(content);

  // --- Native <video> ---
  if (content.tagName === "VIDEO") {
    content.muted = true; // required for autoplay
    content.playsInline = true; // for iOS
    content.autoplay = true;

    // Wait for video metadata before playing
    content.addEventListener("canplay", () => {
      content.play().then(() => {
        this.isPlaying = true;
        this.updatePlayPauseHint(this.isPlaying);
      }).catch(() => {
        console.warn("Video could not autoplay, user gesture required.");
      });
    });
  }

  // --- YouTube iframe ---
  else if (content.tagName === "IFRAME" && /youtube\.com|youtu\.be/.test(content.src)) {
    let src = content.getAttribute("src") || "";
    if (!src.includes("enablejsapi=1")) {
      const sep = src.includes("?") ? "&" : "?";
      src += `${sep}enablejsapi=1&autoplay=1&mute=1&playsinline=1`;
      content.setAttribute("src", src);
    }

    content.onload = () => {
      if (typeof YT !== "undefined" && YT.Player) {
        new YT.Player(content, {
          events: {
            onReady: (event) => {
              event.target.mute();
              event.target.playVideo();
            }
          }
        });
      }
    };

    this.isPlaying = true;
    this.updatePlayPauseHint(this.isPlaying);
  }

  // --- Vimeo iframe ---
  else if (content.tagName === "IFRAME" && /vimeo\.com/.test(content.src)) {
    const sep = content.src.includes("?") ? "&" : "?";
    content.src = `${content.src}${sep}autoplay=1&muted=1`;
    this.isPlaying = true;
    this.updatePlayPauseHint(this.isPlaying);
  }
}






  toggleMedia() {
    if (this.isPlaying) {
      this.pauseMedia();
    } else {
      this.playMedia();
    }
  }

  playMedia() {
    const iframe = this.querySelector("iframe[data-video-type]");
    if (iframe) {
      iframe.contentWindow?.postMessage(
        iframe.dataset.videoType === "youtube"
          ? '{"event":"command","func":"playVideo","args":""}'
          : '{"method":"play"}',
        "*"
      );
    } else {
      this.querySelector("video")?.play();
    }
    this.isPlaying = true;
    this.updatePlayPauseHint(this.isPlaying);
  }

  pauseMedia() {
    const iframe = this.querySelector("iframe[data-video-type]");
    if (iframe) {
      iframe.contentWindow?.postMessage(
        iframe.dataset.videoType === "youtube"
          ? '{"event":"command","func":"pauseVideo","args":""}'
          : '{"method":"pause"}',
        "*"
      );
    } else {
      this.querySelector("video")?.pause();
    }
    this.isPlaying = false;

    if (this.getAttribute("data-media-loaded")) {
      this.updatePlayPauseHint(this.isPlaying);
    }
  }
}

if (!customElements.get("deferred-media")) {
  customElements.define("deferred-media", DeferredMedia);
}
